import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { getNavItemsForRole, itemMatchesRoute } from "@/config/navigation";

// Estado y comportamiento compartido del menú lateral (SideBar y NavDrawer).
// El ítem activo se deriva de la ruta actual, así que sobrevive a recargas y links directos.
export function useNavMenu({ onNavigate } = {}) {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();

  const items = computed(() => getNavItemsForRole(store.state.user?.type));

  // Padre cuyo submenú contiene la ruta actual (si lo hay).
  const activeParent = computed(() =>
    items.value.find((item) =>
      (item.subItems || []).some((sub) => itemMatchesRoute(sub, route.name))
    )
  );

  const expandedItem = ref(activeParent.value?.text || "");

  // Al llegar a una ruta de un submenú (p. ej. por link directo), lo abrimos.
  watch(activeParent, (parent) => {
    if (parent) expandedItem.value = parent.text;
  });

  const isActive = (item) =>
    item.subItems
      ? activeParent.value?.text === item.text
      : itemMatchesRoute(item, route.name);

  const isExpanded = (item) => expandedItem.value === item.text;

  const navigate = (item) => {
    if (!item.route) return;
    router.push({ name: item.route });
    if (onNavigate) onNavigate(item);
  };

  const handleItemClick = (item) => {
    if (item.subItems) {
      expandedItem.value = isExpanded(item) ? "" : item.text;
      return;
    }
    navigate(item);
  };

  return {
    items,
    isActive,
    isExpanded,
    handleItemClick,
    navigate,
  };
}
